import { signal } from '@preact/signals-react';

interface RecordingState {
  recordingInprogress: boolean;
}

export const recordingState = signal<RecordingState>({
  recordingInprogress: false,
});
